import { useState } from 'react';
import axios from 'axios';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [haslo, setHaslo] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/auth/login', { email, haslo });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Błąd logowania');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.container}>
      <div style={s.box}>
        <div style={s.logoWrap}>
          <span style={s.logoIcon}>📦</span>
        </div>
        <h1 style={s.title}>System zamówień do fabryk Timemaster</h1>
        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Email</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="twoj@email.pl"
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Hasło</label>
            <input
              style={s.input}
              type="password"
              value={haslo}
              onChange={e => setHaslo(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          {error && <p style={s.error}>{error}</p>}
          <button style={s.button} type="submit" disabled={loading}>
            {loading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0d1117' },
  box: { background: '#161b22', padding: '40px', borderRadius: '10px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)', width: '380px', border: '1px solid #30363d' },
  logoWrap: { textAlign: 'center', marginBottom: '16px' },
  logoIcon: { fontSize: '40px' },
  title: { margin: '0 0 28px', fontSize: '16px', textAlign: 'center', color: '#8b949e', fontWeight: '500', lineHeight: '1.4' },
  field: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#c9d1d9' },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #30363d', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', background: '#0d1117', color: '#e6edf3', outline: 'none' },
  error: { color: '#ff7875', fontSize: '14px', marginBottom: '12px', background: '#2d1b1b', border: '1px solid #5c2323', padding: '10px 12px', borderRadius: '6px' },
  button: { width: '100%', padding: '12px', background: '#1890ff', color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', cursor: 'pointer', fontWeight: '600', marginTop: '4px' },
};
